import appointmentBookingBaseFlow from "./appointment-booking/flow.module"
import conversationFlow from "./conversation/flow.module"
import coreApiClient from "core-api"
import tradeinOfferRequestBaseFlow from "./tradein-offer-request/flow.module"
import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appOptions: {},
    workspace: null,
    auth: { token: null },
    representativeUser: null
  },
  getters: {
    isApplicationAvailable: (state) => (application) => {
      if (!state.workspace || !state.workspace.applications) {
        return false
      }
      return state.workspace.applications.map(b => b.code).includes(application)
    },
    representativeUserId: state => {
      return state.representativeUser ? state.representativeUser.id : null
    }
  },
  mutations: {
    setAppOptions(state, payload) {
      state.appOptions = payload
    },
    setWorkspace(state, payload) {
      state.workspace = payload
    },
    setAuthToken(state, payload) {
      state.auth.token = payload
    },
    setRepresentativeUser(state, payload) {
      state.representativeUser = payload
    }
  },
  actions: {
    authCustomer(context, payload) {
      return coreApiClient.auth
        .getToken(payload)
        .then(response => {
          context.commit("setAuthToken", response.token)
          return response
        })
        .catch(error => {
          window.console.error(error)
          Promise.reject(error)
        })
    },
    loadWorkspace(context, payload) {
      return coreApiClient.workspaces.readWorkspaceInfo(payload)
        .then(response => {
          context.commit("setWorkspace", response)
        })
        .catch(error => {
          window.console.error(error)
          return Promise.reject(error)
        })
    }
  },
  modules: {
    appointmentBooking: {
      namespaced: true,
      modules: { flow: appointmentBookingBaseFlow }
    },
    conversation: {
      namespaced: true,
      modules: { flow: conversationFlow }
    },
    tradeinOfferRequest: {
      namespaced: true,
      modules: { flow: tradeinOfferRequestBaseFlow }
    }
  },
  strict: process.env.NODE_ENV !== "production"
})
